<template>
    <div>
        <Modal
            ref="dialog"
            v-model="isShow"
            class-name="ivu-noPadding-wrap"
            transfer
            :scrollable="true"
            :closable="closable"
            :width="width"
            :height="height"
            :footer-hide="footerHide"
            :styles="windowStyle"
            :mask-closable="true"
            :draggable=isMove>
            <p id="title" v-show="isTitle" :slot=customTitle>
                <span>{{
                        registerName
                    }}</span><i v-show="isEnlarge" @click="enlarge" style="float: right; margin-right: 27px;font-size: 18px;cursor: zoom-in;">
                <Icon type="ios-expand"/>
            </i></p>
            <div :style="backStyle">
                <svg
                    data-id="svgNode"
                    :style="styleZoom"
                    ref="canvasNode"
                    :id="registerName"
                    :width="canvasX"
                    :height="canvasY"
                    @mousedown.capture="onMouseDown"
                    @mouseup.capture="onMouseUp"
                    @mousemove.capture="onMouseMove"></svg>
                <component :is="item.component" v-for="item in primitivesList"
                           :primitives="item.primitives"
                           :fvSystemApi="item.fvSystemApi"
                           :parentObject="item.parentObject"
                           :key="item.registerName"></component>
                <Spin size="large" fix v-if="spinShow"></Spin>
            </div>
        </Modal>
    </div>


</template>

<style>
/* 无边框 无滚动条*/

.ivu-noPadding-wrap .ivu-modal-body {
    /* overflow:hidden;     */
    padding: 0px;
}

.ivu-noPadding-wrap .ivu-modal-content {
    border-radius: 0;
    box-shadow: 0 0 0 0;
}
</style>
<script>
import Vue from 'vue';
import echarts from 'echarts';

Vue.prototype.$echarts = echarts;
import divUnit from '../../js/div/divUnit';
import fvSystemApi from '../../js/fvSystemApi';

export default {
    name: 'appWindowComponent',
    props: ['windowInfo'],
    created: function () {
        Object.assign(this, this.windowInfo);
        this.canvasX = window.innerWidth;
        this.canvasY = window.innerHeight - this.y;
        this.canvasWidth = window.innerWidth;
        this.canvasHeight = window.innerHeight;
        this.backStyle.backgroundColor = this.borderColor;

        if(this.centerOpen && window.topY != undefined) {
            this.windowStyle = {
                top: window.topY,
                left: window.leftX,
                textAlign: 'left',
                margin: '0 0',
                padding: '0px'
            };
        } else {
            this.windowStyle = {
                top: this.y,
                left: this.x,
                textAlign: 'left',
                margin: '0 0',
                padding: '0px'
            };
        }
        document.onmousewheel = this.onMouseScroll.bind(this);
        if(window.addEventListener)
            window.addEventListener('DOMMouseScroll', document.onmousewheel, false);
        this.modelsPath = ['system', 'manager', this.registerName];
        this.$store.registerModule(this.modelsPath, {
            state: {
                $: this
            }
        });
        this.isScrolly = false;
        this.isScrollx = false;
        this.subObjects = this.$store.state.system.manager[this.registerName];
        //判断是否有标题 有标题加上标题的高度
        if(this.title) {
            this.isTitle = true;
            this.customTitle = 'header';
            this.heightTitle = 37;
            this.heightTitles = 51;
        }
        //判断是否可以拖动
        if(this.dragger) {
            this.isMove = false;
        }
        //系统菜单
        if(this.menuMessage) {
            this.closable = this.menuMessage;
            this.isEnlarge = this.menuMessage;
        }
    },
    async mounted() {
        this.init();
        //app窗口无边框
        this.defaultTailoring = 5;
        this.windowSize = {
            width: this.width,
            height: this.height
        };
        this.zoomMagnification();
        if(this.fcchildren) {
            //先确定canvas大小。this.windowSize属性需要在对象常见时使用
            this.fcchildren.forEach(element => {
                if(element == undefined || element == null) {
                    return;
                }
                //draw边框导致所有图元需要按比例随访位置
                element.frameScaleX = this.defaultTailoring / this.width;
                element.frameScaleY = this.defaultTailoring / this.height;
                if(this.canvasX < element.x + element.width) {
                    this.scrollx = element.x + element.width;
                    this.canvasX = element.x + element.width + this.defaultTailoring;
                    this.isScrollx = true;
                }
                if(this.canvasY < (element.y + element.height) * this.scaleY) {
                    this.scrolly = (element.y + element.height) * this.scaleY;
                    this.canvasY = (element.y + element.height) * this.scaleY + this.defaultTailoring;
                    this.isScrolly = true;
                }
            });
            var func = [];
            for (const element of this.fcchildren) {
                let i = this.fcchildren.indexOf(element);
                if(element == undefined || element == null) {
                    continue;
                }
                func.push(await new Promise((resolve, rejected) => {
                    try {
                        if(Vue.component(element.fctype)) {
                            this.primitivesList.push({
                                component: element.fctype,
                                primitives: element,
                                registerName: element.registerName,
                                parentObject: this,
                                fvSystemApi: new fvSystemApi(this.$store.state.system),
                            });
                            resolve();
                        } else {
                            this.parentX = 0;
                            this.parentY = 0;
                            new divUnit[element.fctype](element, this, this.$refs.canvasNode, (obj) => {
                                this.subObjects[obj.name] = {
                                    '$': obj
                                };
                                this.zIndexObjList.push({
                                    name: obj.name,
                                    zIndex: obj.zIndex
                                });
                                resolve();
                            });
                        }
                    } catch (e) {
                        console.log('此类型不存在：%c' + element.fctype, 'color:#f00;');
                        console.log(e);
                        resolve();
                    }
                }));
            }
            Promise.all(func).then(() => {
                this.fcchildren.forEach((element, i) => {
                    if(element == undefined || element == null) {
                        return;
                    }
                    if(Vue.component(element.fctype)) {
                        this.primitivesList.forEach((e) => {
                            if(element.registerName == e.registerName) {
                                this.subObjects[e.registerName] = this.$store.state.system.manager[e.parentObject.registerName][e.registerName];
                                this.zIndexObjList.push({
                                    name: element.registerName,
                                    zIndex: element.zIndex
                                });
                            }
                        });
                    }
                });
                this.zIndexObjList.sort(function (obj1, obj2) {
                    return obj1.zIndex - obj2.zIndex;
                });
                this.onSuccess();

            });
        }
    },

    // destroyed : function(){
    //     this.isOpenSuccess = false;
    //     //删除vue组件被移除后遗留的iview节点
    //     var body = this.$el;
    //     var div = document.body.children[0].children[0];
    //     div.removeChild(body);
    // },

    data: function () {
        return {
            winType: 'app',
            styleZoom: {},//canvas 缩放样式
            modelsPath: [],
            spinShow: true,
            canvasY: 0,
            canvasX: 0,
            //是否显示系统菜单中的放大
            isEnlarge: false,
            //关闭按钮
            closable: false,
            //自定义标题
            customTitle: '',
            //判断是否拖动
            isMove: true,
            isNowClose: true,
            footerHide: true,
            isTitle: false,
            focusFlag: 1,
            primitivesList: [],
            subObjects: {},
            lastTime: new Date().getTime(),
            isClose: false,
            isShow: true,
            ctx: null,
            scaleFlag: 0,
            olderInnerWidth: 0,
            olderInnerHeight: 0,
            openOne: true,//标记执行一次窗口自适应
            m_nEventOffsetX: 0,
            m_nEventOffsetY: 0,
            zoom: 0,
            domScale: {
                zoom: 0,
                x: this.y,
                y: this.x,
                sx: 1,
                sy: 1,
                ox: 0,
                oy: 0,
                scrollHeight: 0,
                scrollWidth: 0,
                titleHeight: 0
            },
            backStyle: {
                width: parseFloat(this.width) * this.scaleX + 'px',
                height: parseFloat(this.height) * this.scaleY + 'px',
                backgroundColor: 'red'
            },
            isOpenSuccess: false,
            zIndexObjList: [],
            //初始化对话框样式
            windowStyle: {
                top: 0,
                left: 0,
                textAlign: 'left',
                margin: '0 0',
                padding: '0px'
            },
            selected: null,
            heightTitle: 0,
            heightTitles: 0,
            openOtimer: true//控制周期执行
        };
    },

    methods: {
        setTitle(name){
            this.titleName = name;
        },
        async init() {
            this.svgNode = this.$refs.canvasNode;
            this.svgNode.style.width = this.canvasWidth + 'px';
            this.svgNode.style.height = this.canvasHeight + 'px';
            this.onDraw();
        },
        //弹出式窗口点击叉子调用
        cancel() {
            this.$parent.closeWindow(this.registerName);
            this.iscancel = false;
            // this.onClose();
        },
        /*
            参数：无
            作用：计算缩放比例
        */
        zoomMagnification() {
            var y_y = this.GetPercent((parseFloat(this.y)), parseFloat(this.height) + (parseFloat(this.y)));
            this.top = parseFloat(window.innerHeight) * (parseFloat(y_y) / 100);
            this.scaleX = parseFloat(window.innerWidth) / parseFloat(this.width);
            //判断是标题还是系统菜单
            if(this.y == 30) {
                //中间窗口y计算偏差
                this.top = parseFloat(window.innerHeight) * (parseFloat(y_y) / 100) - 4;
                //10像素添加边框的问题
                this.scaleY = (parseFloat(window.innerHeight) - this.top * 2) / (parseFloat(this.height) + 10);
                //设置中间窗口为最高否则滚动条被遮盖
                //this.$refs.dialog.$el.lastChild.style.zIndex = parseFloat(this.$refs.dialog.$el.lastChild.style.zIndex)+5;
            } else if(this.y > 30) {
                this.scaleY = (parseFloat(window.innerHeight) - (this.top)) / (parseFloat(this.height));
            } else if(this.y < 30) {
                //标题的计算，主体和系统菜单不同
                var y_y = this.GetPercent(parseFloat(this.height), 637);
                var top_y = parseFloat(window.innerHeight) - (parseFloat(window.innerHeight) * (parseFloat(y_y) / 100));
                this.scaleY = (parseFloat(window.innerHeight) - top_y) / (parseFloat(this.height));
            }
        },
        getMagnification() {
            return {
                x: this.scaleX,
                y: this.scaleY
            };
        },
        /*
            参数：e 鼠标信息
            作用：最大化。双击标题栏是调用
        */
        enlarge: function (e) {
            this.fullscreen = true;
            this.windowStyle = {
                top: 0,
                left: 0,
                textAlign: 'left',
                margin: '0 0',
                padding: '0px'
            };
            this.repaint();
        },
        /*
            参数：无
            作用：窗口加载完成
        */
        async onSuccess() {
            //因请求窗口json 使用延迟处理，所以进入窗口动作也要同步等待
            setTimeout(() => {
                this.fvScript.executionScript(this.entrancescript, undefined, this.registerName);
            }, 20);
            //设置canvas 的缩放比例
            this.isShow = true;
            this.$store.state.system.$.getData();
            this.svgNode = this.$refs.canvasNode;
            this.onDraw();
            this.spinShow = false;
            this.repaint();
        },
        /*
            参数：time 当前时间
            作用：周期执行函数
        */
        onTimer(time) {
            if(!this.openOtimer) return;
            var currTime = new Date().getTime();
            if(currTime - this.lastTime > 200) {
                this.fvScript.executionScript(this.timerscript);
                this.lastTime = currTime;
                for (var i = 0; i < this.zIndexObjList.length; i++) {
                    var obj = this.zIndexObjList[i];
                    if(!this.subObjects[obj.name].$.display || this.subObjects[obj.name].$.display == 'block') {
                        if(this.subObjects[obj.name].$.onTimer) {
                            this.subObjects[obj.name].$.onTimer(time);
                        }
                    }
                }
                if(this.$store.state.system.$.animationType) {
                    this.onDraw();
                }
            }
        },
        /*
            参数：无
            作用：实时数据更新时被调用
        */
        onUpdata() {
            for (var p in this.subObjects) {
                if(p == '$') {
                    continue;
                }
                if(this.subObjects[p].$.onUpdata) {
                    this.subObjects[p].$.onUpdata();
                }
            }
            ;
        },
        /*
            参数：无
            作用：绘制界面
        */
        onDraw() {
            // if(this.ctx == null) return;
            var browserResize = 0;
            var isRepaint = false;
            //标记手机浏览器只调用一次自适应
            if(this.openOne) {
                if((this.olderInnerWidth == 0 && this.olderInnerHeight == 0)
                    || (this.olderInnerWidth != window.innerWidth)
                    || (this.olderInnerHeight != window.innerHeight)) {
                    browserResize = 1;
                }
            }
            if(browserResize || (this.scaleFlag == 1 && this.scaleWindowType != 0)) {
                this.repaint();
            }

            if(this.$refs.canvasNode && this.$refs.canvasNode.scrollTop) {
                this.domScale.scrollHeight = this.$refs.canvasNode.scrollTop;
                this.domScale.scrollWidth = this.$refs.canvasNode.scrollLeft;
            }
            if(this.spinShow) {
                this.spinShow = false;
            }

            for (var i = 0; i < this.zIndexObjList.length; i++) {
                var obj = this.zIndexObjList[i];
                if(!this.subObjects[obj.name].$.display || this.subObjects[obj.name].$.display == 'block') {
                    if(this.subObjects[obj.name].$.type == 'basic' || this.subObjects[obj.name].$.type == 'group') {
                        try {
                            // console.log(this.svgNode)
                            this.subObjects[obj.name].$.onDraw(this.subObjects[obj.name].$);
                        } catch (error) {
                            console.log('**********' + obj.name + '无onDraw函数**********');
                            console.log(error);
                        }
                    }
                }
            }

            //绘制完清空缓存，否则大小改变时有重影
            if(!this.$store.state.system.$.animationType) {
                requestAnimationFrame(this.onDraw.bind(this));
            }
        },
        /*
            参数：无
            作用：窗口关闭前被调用
        */
        onClose() {
            this.openOtimer = false;
            var _this = this;
            return new Promise(function (resolve) {
                _this.fvScript.executionScript(_this.exitscript);
                var funcs = [];
                for (var p in _this.subObjects) {
                    if(p == '$') {
                        continue;
                    }
                    if(_this.subObjects[p].$.onClose) {
                        funcs.push(_this.subObjects[p].$.onClose());
                    }
                }
                ;
                Promise.all(funcs).then(() => {
                    if(_this.$el) {
                        if(_this.$el.childNodes[0].length != 0)
                            _this.$el.removeChild(_this.$el.childNodes[0]);
                    }
                    resolve();
                });
            });

        },
        /*
            参数：isShow 显隐标记
            作用：设置窗口显隐
        */
        show(isShow) {
            this.isShow = isShow ? true : false;
        },
        GetPercent(num, total) {
            var num = parseFloat(num);
            var total = parseFloat(total);
            if(isNaN(num) || isNaN(total)) {
                return '-';
            }
            return total <= 0 ? '0%' : (Math.round(num / total * 10000) / 100.00 + '%');
        },
        repaint() {
            this.svgNode.style.zoom = 1;
            this.zoomMagnification();
            var pos = {
                'width': parseFloat(this.width) * this.scaleX + 'px',
                'height': parseFloat(this.height) * this.scaleY + 'px',
                'left': parseFloat(this.x) * this.scaleX + 'px',
                'top': this.top + 'px'
            };
            this.domScale = {
                zoom: this.zoom,
                x: parseFloat(pos.left),//窗口位置x
                y: parseFloat(pos.top),//窗口位置y
                sx: this.scaleX,//缩放比例x
                sy: this.scaleY,//缩放比例y
                ox: this.m_nEventOffsetX,//位置偏移x
                oy: this.m_nEventOffsetY,//位置偏移y
                titleHeight: this.title ? 51 : 0,//
                scrollHeight: this.$refs.canvasNode.scrollTop,
                scrollWidth: this.$refs.canvasNode.scrollLeft
            };
            //判断边框给与赋值后在高度减去
            var bw = this.setWindowStyle();
            //设置 canvas 父级元素的大小以及宽高
            // this.svgNode.parentElement.style.width = pos.width;
            // this.svgNode.parentElement.style.height = pos.height;
            //设置高度宽度
            this.$refs.dialog.$el.lastChild.style.width = parseInt(pos.width) + 'px';
            this.$refs.dialog.$el.lastChild.style.height = parseInt(pos.height) + 'px';

            //设置三个窗口的位置
            this.$refs.dialog.$el.lastChild.style.top = pos.top;
            if(!this.isScrolly) {
                this.$refs.dialog.$el.lastChild.style.overflow = 'hidden';
            }
            //赋值，判断防止再次调用
            this.olderInnerWidth = window.innerWidth;
            this.olderInnerHeight = window.innerHeight;
            this.openOne = false;
            //设置如果超出浏览器宽高 出现滚动条
            // this.$refs.dialog.$refs.content.style.overflow = "auto";
            // this.$refs.dialog.$refs.content.style.width = window.innerWidth +"px";
            // this.$refs.dialog.$refs.content.style.height = window.innerHeight +"px";
            //判断高度来设置滚动条
            if(parseFloat(pos.height) < window.innerHeight) {
                this.$refs.dialog.$refs.content.style.width = parseInt(pos.width);
                this.$refs.dialog.$refs.content.style.height = parseInt(pos.height);
            }
            //设置canvas 宽高
            this.svgNode.style.width = parseInt(pos.width) * devicePixelRatio;
            this.svgNode.style.height = parseInt(pos.height) * devicePixelRatio;

            //判断是否显示滚动条
            //判断启用 y滚动条
            if(this.isScrolly) {
                this.svgNode.style.height = this.scrolly * devicePixelRatio;
            }
            //设置子元素始终在在最上端
            this.$refs.dialog.$refs.content.parentElement.style.top = 0;
            this.$refs.dialog.$refs.content.parentElement.style.left = 0;
            //设置隐藏遮罩层
            this.$refs.dialog.$el.firstChild.style.display = 'none';
            // this.ctx.translate(this.m_nEventOffsetX, this.m_nEventOffsetY);
            this.reDraw();
            this.repaintStyle();
        },
        /*
         参数：无
         作用：界面计算后再次重绘样式

     */
        repaintStyle() {
            if(this.$refs.svgNode && this.$refs.svgNode.scrollTop) {
                this.domScale.scrollHeight = this.$refs.svgNode.scrollTop;
                this.domScale.scrollWidth = this.$refs.svgNode.scrollLeft;
            }
            if(this.spinShow) {
                this.spinShow = false;
            }
            for (var i = 0; i < this.zIndexObjList.length; i++) {
                var obj = this.zIndexObjList[i];
                if(!this.subObjects[obj.name].$.display || this.subObjects[obj.name].$.display == 'block') {
                    if(this.subObjects[obj.name].$.type == 'basic' || this.subObjects[obj.name].$.type == 'group') {
                        try {
                            if(this.subObjects[obj.name].$.createStyle == undefined) continue;
                            this.subObjects[obj.name].$.createStyle(this.svgNode);
                        } catch (error) {
                            console.log('**********' + obj.name + '无onDraw函数**********');
                            console.log(error);
                        }

                    }
                }
            }
        },
        /*
            参数：无
            作用：重绘
        */
        reDraw() {

            for (var p in this.subObjects) {
                try {
                    if(p == '$') {
                        continue;
                    }
                    if(this.subObjects[p].$.reDraw) {
                        this.subObjects[p].$.reDraw(this.domScale);
                    }
                } catch (error) {
                    console.log('**********' + p + ' reDraw函数**********');
                    console.log(error);
                }
            }
            this.onDraw();

        },
        /*
            参数：e 鼠标信息
            作用：鼠标按下时被调用
        */
        onMouseDown(e) {
            e.stopPropagation();
            for (const item of this.getMousePositionDom(e)) {
                item.style.display = "block";
                if (item.onmousedown == undefined) continue;
                item.onmousedown(e);
            }
        },

        /*
            参数：e 鼠标信息
            作用：鼠标弹起时被调用
        */
        onMouseUp(e) {
            e.stopPropagation();
            this.getMousePositionDom(e).forEach(item => {
                item.style.display = "block";
                if (item.onmouseup == undefined) return;
                item.onmouseup(e);
            })
        },

        /*
            参数：e 鼠标信息
            作用：鼠标移动时被调用
        */
        onMouseMove(e) {
            e.stopPropagation();
            this.getMousePositionDom(e).forEach(item => {
                item.style.display = "block";
                if (item.onmousemove == undefined) return;
                item.onmousemove(e);
            })
        },
        /*
            参数：e 鼠标信息
            作用：鼠标中键操作时被调用
        */
        onMouseScroll(e) {
            if(e.preventDefault && e.ctrlKey)
                e.preventDefault();
            if(e.ctrlKey) {
                e.returnValue = false;
                this.focusFlag = true;
            } else {
                this.focusFlag = false;
            }

            if(this.focusFlag) {
                if(e.wheelDelta) {//IE/Opera/Chrome
                    this.$store.state.system.$.scrollType = e.wheelDelta > 0 ? true : false;
                } else if(e.detail) {//Firefox
                    this.$store.state.system.$.scrollType = e.detail > 0 ? true : false;
                }
                if(this.$store.state.system.$.scrollType) {
                    this.scaleFlag = 1;
                    this.$store.state.system.$.step += 0.01;
                } else {
                    this.scaleFlag = 1;
                    this.$store.state.system.$.step -= 0.01;

                }
                this.$store.state.system.$.m_nMousePosX = e.pageX;
                this.$store.state.system.$.m_nMousePosY = e.pageY;
                return;
            }
        },
        /*
            参数：e 鼠标信息
            作用：获取鼠标坐标下的元素
        */
        getMousePositionDom(e) {
            let x = e.clientX;
            let y = e.clientY;
            let domArr = [];
            (function getPositionDownDom() {
                let dom = document.elementFromPoint(x, y);
                if(dom == null || dom.getAttribute('data-id') == 'svgNode') {
                } else {
                    // 处理父级为g标签,并且方法在g标签上
                    if(dom.parentNode && dom.parentNode.tagName.toLowerCase() == 'g') {
                        domArr.push(dom.parentNode);
                    }
                    domArr.push(dom);
                    dom.style.display = 'none';
                    return getPositionDownDom();
                }
            }());
            this.noRepeat(domArr);
            return domArr;
        },
        // 数组去重
        noRepeat(arr) {
            for (let i = 0; i < arr.length - 1; i++) {
                for (let j = i + 1; j < arr.length; j++) {
                    if(arr[i] === arr[j]) {
                        arr.splice(j, 1);
                        j--;
                    }
                }
            }
            return arr;
        },
        /*
            参数：无
            作用：设置窗口
        */
        setWindowStyle() {
            var bw = 0;
            if(this.borderWidth == 1) {
                bw = 4;
            } else if(this.borderWidth == 2) {
                bw = 10;
            }
            return bw;
        },
        cleanUpFource() {
            this.isFocusWindow = false;
        },

    }
};


</script>



// WEBPACK FOOTER //
// src/components/system/appWindowComponentSvg.vue